import React from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import '../assets/css/modal.css';
const BASE_URL = process.env.REACT_APP_CONVIS_URL;

class SubTopicLLMModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // generated summary
      conversations: props.conversations,
      inputContent: props.inputContent,
      faqs: props.faqs,
      answerGenerating: false,
      chatMessages : props.chatMessages,
      chatInput: '',
      selectedKeywords: [],
      selectedChallenges: [],
    };
    this.handleChatInputChange = this.handleChatInputChange.bind(this);
    this.handleChatSubmit = this.handleChatSubmit.bind(this);
    this.handleLLMCall = this.handleLLMCall.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.conversations !== this.props.conversations) {
      this.setState({ conversations: nextProps.conversations});
    }
    if (nextProps.inputContent !== this.props.inputContent) {
      this.setState({ inputContent: nextProps.inputContent});
    }
    if (nextProps.chatMessages !== this.props.chatMessages) {
      this.setState({ chatMessages: nextProps.chatMessages});
    }
    if (nextProps.faqs !== this.props.faqs) {
      this.setState({ faqs: nextProps.faqs});
    }
  }

  componentDidMount() {
    document.addEventListener('change', this.handleCheckboxChange.bind(this));
    document.addEventListener('keydown', this.handleKeyDown.bind(this));
  }
  
  componentWillUnmount() {
    document.removeEventListener('change', this.handleCheckboxChange.bind(this));
    document.removeEventListener('keydown', this.handleKeyDown.bind(this));
  }  

  handleKeyDown(event) {
    if (event.key === 'Enter') {
      event.preventDefault(); // Prevent the default form submission
      this.handleChatSubmit();
    }
  }

  handleLLMCall(chatInput) {
    this.setState({ answerGenerating: true });
    const url = `${BASE_URL}/api/nlp_explorer/nlp_chat`;
    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ text: chatInput, context: this.state.inputContent, selected_keywords: this.state.selectedKeywords, selected_challenges: this.state.selectedChallenges }),
      credentials: "include"
    })
      .then(response => response.json())
      .then(data => {
        console.log('Success:', data);
        const newMessage = { user: 'ai', text: data.answer };
        this.setState(prevState => ({
          chatMessages: [...prevState.chatMessages, newMessage],
        }));
        this.setState({ answerGenerating: false });
      })
      .catch(error => {
        console.error('Error:', error);
      });
  }

  handleChatInputChange(event) {
    console.log("input faqs:", this.state.faqs)
    this.setState({ chatInput: event.target.value });
    this.handleCheckboxChange();
  }

  handleChatSubmit() {
    const newMessage = { user: 'user', text: this.state.chatInput };
    const text = this.state.chatInput;
    this.setState(prevState => ({
      chatMessages: [...prevState.chatMessages, newMessage],
      chatInput: ''
    }));
    this.handleLLMCall(text);
  }

  getCheckedCheckboxes() {
    const keywordCheckedCheckboxes = document.querySelectorAll('input.keyword-checkbox:checked');
    const challengeCheckedCheckboxes = document.querySelectorAll('input.challenge-checkbox:checked');
    const checkedValues = {'Keywords': [], 'Challenges': []};
    keywordCheckedCheckboxes.forEach(checkbox => {
      checkedValues['Keywords'].push(checkbox.value);
    });
    challengeCheckedCheckboxes.forEach(checkbox => {
      checkedValues['Challenges'].push(checkbox.value);
    });
    this.setState({ selectedKeywords: checkedValues['Keywords'] });
    this.setState({ selectedChallenges: checkedValues['Challenges'] });
    return checkedValues;
  }

  handleCheckboxChange() {
    const checkedValues = this.getCheckedCheckboxes();
    console.log('Checked keyword values:', this.state.selectedKeywords);
    console.log('Checked challenge values:', this.state.selectedChallenges);
  }
  
  toggleFaq(index) {
    const answerElement = document.getElementById(`faq-answer-${index}`);
    console.log('id:', `faq-answer-${index}`);
    console.log('answerElement:', answerElement);
    try{
      if (answerElement.style.display === 'none') {
        answerElement.style.display = 'block';
      } else {
        answerElement.style.display = 'none';
      }
    } catch (e) {
      console.log('Error toggling FAQ answer:', e);
    }
  }

  render() {
    const modalStyle = {
        margin: '10 auto',
        transition: 'all .8s',
    };

    const headerStyle = {
        background: 'lightSteelBlue',
    };

    const bodyStyle = {
        background: '#F6F6F6',
    };
    return (
      <Modal 
        id='SubtopicLLMModal'
        centered
        style={modalStyle}
        // className="modal-style"
        animation={false}
        show={this.props.show} 
        onHide={this.props.handleClose}>
        <Modal.Header style={headerStyle} closeButton>
          <Modal.Title>LLM Recommendations</Modal.Title>
        </Modal.Header>
        <Modal.Body 
            style={bodyStyle}
            // className="modal-content show-grid"
            >
          {/* <Form>
            <Form.Group controlId="formConversations">
              <Form.Label>Conversations</Form.Label>
              <Form.Control
                as="textarea"
                rows={5}
                value={this.state.conversations}
                onChange={this.handleChange}
                placeholder="Enter conversations here"
              />
            </Form.Group>
          </Form> */}
            <div className="modal-content-container">
            <div className="left-column">
            {this.props.conversations?
              <div dangerouslySetInnerHTML={{ __html: this.state.conversations }} />:
              <div>
                <div
                  className="info-preloader-handler"
                  style={{
                    position: 'absolute',
                    top: '40%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    height: 'auto',
                    zIndex: 15,
                    background: 'transparent',
                    borderRadius: '5px',
                    padding: '10px',
                  }}
                >
                  <div className="preloader-text">
                    <span>Loading...</span>
                    <br />
                    <i className="fa fa-spinner fa-spin"></i>
                  </div>
                </div>
              </div>
            }
            {this.props.svgContent? <div ref={node => node && node.appendChild(this.props.svgContent)} /> : null}
            </div>
            {!this.state.answerGenerating?
            <div className="right-column">
            {this.state.faqs?
            <div className='faq-container'>
              <h4>FAQs</h4>
              <div className="faqs">
                {this.state.faqs.map((faq, index) => (
                  <div className="faq-item" key={"faq-item-"+index}>
                    <button className="faq-question" onClick={() => this.toggleFaq(index)}>{faq.faq}</button>
                    <div className="faq-answer" key={"faq-answer-"+ index} id={"faq-answer-"+ index} style={{display: 'none'}}>
                      {faq.answer}
                    </div>
                  </div>
              ))}
              </div>
              </div>: null}
              <div className="chat-display-area">
                {this.state.chatMessages.map((message, index) => (
                  <div key={index} className={`chat-message ${message.user}`}>
                    <div dangerouslySetInnerHTML={{ __html: message.text}} />
                  </div>
                ))}
              </div>
              <Form className="chat-input-form">
                <Form.Group controlId="formChatInput" className="chat-input-group">
                  <Form.Control
                    type="text"
                    value={this.state.chatInput}
                    onChange={this.handleChatInputChange}
                    placeholder="Enter your message here"
                  />
                </Form.Group>
                <Button variant="primary" onClick={this.handleChatSubmit} className="chat-submit-button">
                  Send
                </Button>
              </Form>
            </div>
            : 
            <div>
              <div className="right-column">
                <div className="chat-display-area" style={{height: '75vh',textAlign: 'center',alignContent: 'center', minWidth: '35vw'}}>
                  <h4>Loading...</h4>
                </div>
              <Form className="chat-input-form">
                <Form.Group controlId="formChatInput" className="chat-input-group">
                  <Form.Control
                    type="text"
                    value={this.state.chatInput}
                    onChange={this.handleChatInputChange}
                    placeholder="Enter your message here"
                  />
                </Form.Group>
                <Button variant="primary" onClick={this.handleChatSubmit} className="chat-submit-button" disabled>
                  Send
                </Button>
              </Form>
            </div>
            </div>
            }
          </div>
        </Modal.Body >
        <Modal.Footer>
          <Button variant="secondary" onClick={this.props.handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default SubTopicLLMModal;